<template>
<div class="invoices">
  <breadcrumb :items="[{ text: 'Boletos', active: true }]" />
  <h4 class="card-title">Boletos em aberto</h4>
  <div class="text-right filters" v-if="isAdmin || isManager">
    Filtrar por:
    <b-dropdown :text="
          filters.supplier
            ? suppliers.find((s) => s._id == filters.supplier).name
            : 'Fornecedor'
        " variant="outline-default" class="mb-3" size="sm">
      <b-dropdown-item @click="
            filters.supplier = null;
            applyFilters();
          ">Todos os fornecedores</b-dropdown-item>
      <b-dropdown-item v-for="(supplier, index) in suppliers" :key="index" @click="
            filters.supplier = supplier._id;
            applyFilters();
          ">{{ supplier.name }}</b-dropdown-item>
    </b-dropdown>
    <b-dropdown :text="
          filters.organization
            ? organizations.find((s) => s._id == filters.organization).name
            : 'Rede'
        " variant="outline-default" class="mb-3" size="sm" v-if="isAdmin">
      <b-dropdown-item @click="
            filters.organization = null;
            applyFilters();
          ">Todas as redes</b-dropdown-item>
      <b-dropdown-item v-for="(organization, index) in organizations" :key="index" @click="
            filters.organization = organization._id;
            applyFilters();
          ">{{ organization.name }}</b-dropdown-item>
    </b-dropdown>
  </div>
  <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>
  <loading :loading="!current_invoices && !error" msg="Carregando lista de pedidos" />
  <no-item :list="current_invoices" />
  <table class="table b-table b-table-stacked-lg" v-if="current_invoices && current_invoices.length">
    <thead>
      <tr>
        <th>Pedido</th>
        <th>Nome do Cliente</th>
        <th>Data de Vencimento</th>
        <th>Valor</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(invoice, index) in current_invoices" :key="index">
        <td>
          <router-link :to="'/pedido/' + invoice.order._id">Pedido #{{ invoice.order.code }}</router-link>
        </td>
        <td>
          {{ invoice.order.name }}
        </td>
        <td>
          <small>{{ invoice.dueDate | data }}</small>
        </td>
        <td>{{ invoice.value | moeda }}</td>
        <td>
          <span @click="updateInvoiceStatus(invoice._id)" class="badge invoice-status" :class="{
              'badge-primary': invoice.status == '1',
              'badge-danger': invoice.status == ('5' || '6' || '7'),
              'badge-success': invoice.status == ('2' || '3' || '4'),
            }">{{ parseStatusCode(invoice.status) }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <p class="text-center" v-if="finished_invoices && finished_invoices.length">
    <button type="button" @click="show_finished = !show_finished" class="btn btn-default">
      {{ show_finished ? "Esconder" : "Exibir" }} pedidos
      concluídos/cancelados
    </button>
  </p>
  <table class="table b-table b-table-stacked-lg" v-if="show_finished && finished_invoices && finished_invoices.length">
    <thead>
      <tr>
        <th>Valor</th>
        <th>Data</th>
        <th>Items</th>
        <th>Total</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(invoice, index) in finished_invoices" :key="index">
        <td>
          <router-link :to="'/pedido/' + invorder._id">Boleto #{{ invoice._id }}</router-link>
        </td>
        <td>
          <small>{{ invoice.dueDate | data }}</small>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import axios from "axios";
import Loading from "@/components/Loading";
import NoItem from "@/components/NoItem";

export default {
  name: "Orders",
  data() {
    return {
      filtered_invoices: null,
      current_invoices: null,
      finished_invoices: null,
      invoices: null,
      suppliers: null,
      organizations: null,
      show_finished: false,
      filters: {
        supplier: null,
        organization: null,
      },
    };
  },
  created() {
    this.getInvoices()
  },
  methods: {
    getInvoices() {
      axios
        .get("invoices")
        .then((response) => {
          this.invoices = response.data;
          var suppliers = {};
          var organizations = {};
          this.invoices.forEach((invoice) => {
            invoice.order.items.forEach((item) => {
              if (item.offer && item.offer.supplier) {
                suppliers[item.offer.supplier._id] = item.offer.supplier;
              }
              if (item.offer && item.offer.organization) {
                organizations[item.offer.organization._id] =
                  item.offer.organization;
              }
            });
          });

          this.suppliers = Object.values(suppliers);
          this.organizations = Object.values(organizations);
          this.applyFilters();
        })
        .catch(this.showError);
    },
    orderTotal(order) {
      var total = order.items
        .filter((i) => i.status != "canceled")
        .reduce((a, b) => {
          return a + b.total;
        }, 0);
      if (order.shipping_price) {
        total += order.shipping_price;
      }
      return total;
    },
    updateInvoiceStatus(id) {
      axios
        .get("invoices/" + id + "/updated")
        .then(() => {
          this.getInvoices();
        })
        .catch(this.showError);
    },
    parseStatusCode(statusCode) {
      switch (Number(statusCode)) {
        case 1:
          return "Processado";
        case 2:
          return "Pago";
        case 3:
          return "Pago depois do vencimento";
        case 4:
          return "Pago depois do cancelamento";
        case 5:
          return "Vencido";
        case 6:
          return "Cancelado";
        case 7:
          return "Cancelado pelo banco";
        default:
          return "Status não identificado";
      }
    },
    applyFilters() {
      this.filtered_invoices = this.invoices;
      if (this.filters.supplier) {
        this.filtered_invoices = this.filtered_invoices.filter((order) => {
          return order.items.find((item) => {
            return item.offer.supplier._id == this.filters.supplier;
          });
        });
      }
      if (this.filters.organization) {
        this.filtered_invoices = this.filtered_invoices.filter((order) => {
          return order.items.find((item) => {
            return item.offer.organization._id == this.filters.organization;
          });
        });
      }

      this.current_invoices = this.filtered_invoices.filter((order) => {
        return !order.status || order.status < 100;
      });
      this.finished_invoices = this.filtered_invoices.filter((order) => {
        return order.status >= 100;
      });
    },
  },

  components: {
    Loading,
    NoItem,
  },
};
</script>
<style lang="sass" scoped>
.invoice-status
    width: 100%
    background-size: 20%
    cursor: pointer
</style>
